function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.29294 6.4143V19.293C2.29294 19.8453 2.74065 20.293 3.29294 20.293H16.1716L14.6716 18.793H3.79294V7.9143L2.29294 6.4143ZM16.5072 16.3859V5.79297H5.91425L4.41425 4.29297H17.0072C17.5595 4.29297 18.0072 4.74068 18.0072 5.29297V10.8941L21.4201 8.61543C21.7523 8.39359 22.1977 8.63175 22.1977 9.03126V15.5549C22.1977 15.9544 21.7523 16.1926 21.4201 15.9708L18.0072 13.6921V17.8859L16.5072 16.3859Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2.06067,
  y: 3,
  width: 25,
  height: 1.5,
  rx: 0.75,
  transform: "rotate(45 2.06067 3)",
  fill: "white"
});

function SvgCameraOffWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOffWhite);
export default __webpack_public_path__ + "static/media/camera-off-white.f3d4278b.svg";
export { ForwardRef as ReactComponent };